export default __webpack_public_path__ + "static/media/logo_mark_pofsis_business.a671fd65.png";